module.exports = __webpack_public_path__ + "static/img/case_banner_14.ced3bfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_banner_14.png
// module id = E+Z6
// module chunks = 34